import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useEffectOnce } from 'react-use';
import { logError } from 'commons/logger';
import getEnvValue from '@/joystagram-components/commons/getEnvValue';

// The RudderStack SDK must be instantiated exactly once per page load.
// RudderAnalyticsProvider wraps the whole app and can remount (hydration /
// Suspense churn observed on Dev and Staging). Because `new RudderAnalytics()`
// reassigns window.rudderanalytics to a fresh, not-yet-loaded instance, a
// remount would clobber the already-loaded instance — its anonymousId reads
// back as null and subsequent track() calls (e.g. add_to_cart) are silently
// dropped instead of reaching Google Tag Manager (CON-8265). Holding the
// instance in a module-level singleton makes initialisation idempotent across
// remounts so there is always exactly one live SDK instance.
let analyticsPromise = null;
const loadRudderAnalytics = async () => {
  const {
    RudderAnalytics
  } = await import('@rudderstack/analytics-js');
  const analyticsInstance = new RudderAnalytics();
  analyticsInstance.load(getEnvValue('NEXT_PUBLIC_RUDDER_STACK_WRITE_KEY'), getEnvValue('NEXT_PUBLIC_RUDDER_STACK_DATA_PLANE_URL'));
  return analyticsInstance;
};
const useRudderStackAnalytics = () => {
  const $ = _c(1);
  const [analytics, setAnalytics] = useState();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (!analyticsPromise) {
        analyticsPromise = loadRudderAnalytics();
      }
      analyticsPromise.then(setAnalytics).catch(_temp);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffectOnce(t0);
  return analytics;
};
export default useRudderStackAnalytics;
function _temp(e) {
  return logError(e, "Error initializing RudderAnalytics instance");
}